export const consultationStatus = {
  new: 'new',
  checkingMedicalProfile: 'checking_medical_profile',
  inProgress: 'in_progress',
  closed: 'closed',
} as const

export type ConsultationStatus = typeof consultationStatus[keyof typeof consultationStatus]
